import script from "./FriendlyDateTime.vue?vue&type=script&lang=ts&setup=true"
export * from "./FriendlyDateTime.vue?vue&type=script&lang=ts&setup=true"

import "./FriendlyDateTime.vue?vue&type=style&index=0&id=21c17d21&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21c17d21"]])

export default __exports__